<template>
  <div class="sidebar-nav">
    <h2 v-if="title == 'OFFERS'" class="sidebar-nav__title">
      <font-awesome-icon icon="tag" />
      {{ title }}
    </h2>
    <h2 v-if="title == 'MERCHANTS'" class="sidebar-nav__title">
      <font-awesome-icon icon="user" />
      {{ title }}
    </h2>

    <h2 v-if="title == 'OUTLETS'" class="sidebar-nav__title">
      <font-awesome-icon icon="store" />
      {{ title }}
    </h2>

    <ul>
      <!-- View routes -->
      <router-link
        tag="li"
        class="sidebar-nav__item"
        active-class="sidebar-nav__item--active"
        v-for="(link, index) in links"
        :key="index"
        @click="toggle()"
        router
        :to="link.route"
        >{{ link.name }}</router-link
      >

      <!-- Modal routes -->
      <span
        v-if="title == 'OUTLETS'"
        tag="li"
        class="sidebar-nav__item"
        active-class="sidebar-nav__item--active"
        @click="showOutletModal()"
        >Create outlet</span
      >
      <span
        v-if="title == 'MERCHANTS'"
        tag="li"
        class="sidebar-nav__item"
        active-class="sidebar-nav__item--active"
        @click="showMerchantModal()"
        >Create merchant</span
      >
    </ul>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "sidebar-nav",

  props: {
    title: {
      type: String,
      required: false
    },

    links: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  data() {
    return {};
  },

  methods: {
    ...mapActions({
      switchToggle: "ui/switchToggle",
      toggleOutletModal: "ui/outletModalState",
      toggleMerchantModal: "ui/merchantModalState"
    }),

    toggle() {
      this.switchToggle();
    },

    showOutletModal() {
      this.toggleOutletModal();
      this.switchToggle();
    },

    showMerchantModal() {
      this.toggleMerchantModal();
      this.switchToggle();
    }
  },

  watch: {
    $route() {
      this.toggle();
    }
  }
};
</script>

<style lang="sass" scoped>
.sidebar-nav
  padding-right: 10px
  color: $c-gray
  font-size: 14px

  &__title
    padding-left: 23px
    margin: 10px 0
    font:
      size: 12px
      weight: normal
      family: Roboto
    text-transform: uppercase
    letter-spacing: 1px

  &__item
    position: relative
    padding: 5px 0
    padding:
      left: 23px
      right: 20px
    cursor: pointer

    &:hover
      color: $c-white

      &::before
        position: absolute
        left: -25px
        height: 100%
        border-left: 4px solid $c-white
        content: ''

    &--active
      color: $c-white

      &::before
        position: absolute
        left: -25px
        height: 100%
        border-left: 4px solid $c-white
        content: ''
</style>
